import React from 'react';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import LoaderButton from '../../LoaderButton/LoaderButton';
import AdNewFormCondition from './AdNewFormCondition';
import AdNewFormVehicle from './AdNewFormVehicle';
import AdNewFormService from './AdNewFormService';
import AdNewFormImage from './AdNewFormImage';
import AdNewFormDescriptions from './AdNewFormDescriptions';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const validate = (values) => {
  const defaultErrorMessage = 'Required';
  const errors = {
    first_registration: (!values.first_registration ||
                          (new Date() < new Date(values.first_registration))) && defaultErrorMessage,
    last_inspection: (new Date() < new Date(values.last_inspection)) && defaultErrorMessage,
    brand_id: !values.brand_id && defaultErrorMessage,
    model: !values.model && defaultErrorMessage,
    price: !values.price && defaultErrorMessage,
    vat_rate: !values.vat_rate && defaultErrorMessage,
    vehicle_type: !values.vehicle_type && defaultErrorMessage,
    total_mileage: !values.total_mileage && defaultErrorMessage,
    vin: ![0, 17].includes(values.vin ? values.vin.length : 0) && defaultErrorMessage,
  };
  const validKeys = Object.keys(errors).filter((error) => !errors[error]);
  validKeys.forEach((key) => delete errors[key]);
  return errors;
};

const focusOnErrors = createDecorator();

const AdNewForm = (props) => {
  const { onSubmit, isLoading, initialValues, existingPhotos, t, } = props;
  const styles = useStyles();
  const removePhoto = ([id], state, { changeValue, }) => {
    changeValue(state, 'photos_attributes', () => [...state.formState.values.photos_attributes.filter((element, index) => index !== id)]);
  };

  return (
    <div>
      <Form
        onSubmit={onSubmit}
        validate={validate}
        mutators={{ removePhoto, }}
        decorators={[focusOnErrors]}
        initialValues={initialValues}
        render={({ handleSubmit, values: { drive_type, new_inspection, photos_attributes, },
                   // eslint-disable-next-line no-shadow
                   form: { mutators: { removePhoto, }, }, }) => (
                     <form onSubmit={handleSubmit} className={styles.form}>
                       <h2 className={styles.title}>{t('condition')}</h2>
                       <AdNewFormCondition currentDriveType={drive_type} />

                       <h2 className={`${styles.title} ${styles.nextTitle}`}>{t('vehicle')}</h2>
                       <AdNewFormVehicle />

                       <h2 className={`${styles.title} ${styles.nextTitle}`}>{t('photos')}</h2>
                       <AdNewFormImage
                         removePhoto={removePhoto}
                         photosAttributes={photos_attributes}
                         existingPhotos={existingPhotos}
                       />

                       <h2 className={`${styles.title} ${styles.nextTitle}`}>{t('servicing')}</h2>
                       <AdNewFormService newInspection={new_inspection} />

                       <h2 className={`${styles.title} ${styles.nextTitle}`}>{t('descriptions')}</h2>
                       <AdNewFormDescriptions formType="react-final-form" />

                       <div>
                         <LoaderButton
                           className={styles.submitButton}
                           isLoading={isLoading}
                           label={t('submit')}
                         />
                       </div>
                     </form>
        )}
      />
    </div>
  );
};

const useStyles = createUseStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: 30,
    paddingTop: 8,
    paddingRight: 15,
    paddingBottom: 8,
    paddingLeft: 15,
    fontSize: 20,
    fontWeight: 700,
    color: '#6c6473',
    backgroundColor: '#f7f7f7',
  },
  nextTitle: {
    marginTop: 30,
    borderTop: '2px solid #d6d2d8',
  },
  submitButton: {
    marginBottom: 30,
    marginLeft: 15,
  },
});

const mapStateToProps = (state) => {
  return {
    isLoading: get(state, ['loader', 'isLoading']),
  };
};

AdNewForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  existingPhotos: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

AdNewForm.defaultProps = {
  existingPhotos: [],
};

export default compose(
  connect(mapStateToProps, null),
  withScopedTranslations('ad_vehicle_description')
)(AdNewForm);
